import { render, staticRenderFns } from "./BaseTitleTable.vue?vue&type=template&id=331fbe8a&"
import script from "./BaseTitleTable.vue?vue&type=script&lang=js&"
export * from "./BaseTitleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331fbe8a')) {
      api.createRecord('331fbe8a', component.options)
    } else {
      api.reload('331fbe8a', component.options)
    }
    module.hot.accept("./BaseTitleTable.vue?vue&type=template&id=331fbe8a&", function () {
      api.rerender('331fbe8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTitleTable.vue"
export default component.exports